



































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {LadingStore} from "../../../store";
import {camelize, enumToOptions} from "@/shared/services/helper/utils";
import {BillLadingFeeType} from "@/enums/type/billladingfeetype";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import {getDetailCostUpdate} from "@/modules/ladings/services";
import get from 'lodash/get';

@Component({
    name: "InfoFeeLading",
    components: {InputCurrency}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly ladingRowGuid!: string;
    getProp = get
    inputSize = 'small';
    BillLadingFeeType = BillLadingFeeType;
    feeOptions = enumToOptions(BillLadingFeeType);
    camelize = camelize;
    visibleCostUpdate = false;
    costUpdateTranshipment = [] as any;
    columnCosts = [
        {
            title: 'Bưu cục',
            dataIndex: 'postOffice.name',
            key: 'postOffice',
            width: 30
        },
        {
            title: 'Phí',
            dataIndex: 'money',
            key: 'money',
            width: 20,
            scopedSlots: { customRender: 'money' }
        }
    ];

    get lading() {
        return LadingStore.data[this.ladingRowGuid];
    }

    totalFeeLading() {
        let result;
        result = this.feeOptions.reduce((previousValue, currentValue) => {
            return previousValue + this.getProp(this.lading, this.camelize(currentValue.label), 0)
        }, 0)
        result += this.getProp(this.lading, 'feeTranshipment', 0)
        return result
    }

    async getDetailCostUpdate() {
        try {
            const { data } =  await getDetailCostUpdate({ billLadingRowGuid: this.ladingRowGuid, typeCost: 5 });
            this.costUpdateTranshipment = data.datas;
            this.visibleCostUpdate = true;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }
}
